import React from 'react';
import TypeaheadComp from '../../../Componant/Forms/FormWidget/TypeaheadComponent/Typeahead';

const Typeahead = () => {
  return (
    <div className='page-body'>
      <TypeaheadComp />
    </div>
  );
};

export default Typeahead;
